import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fRef } from '../../utils/React.js';
import { hostClass as hostClass$1 } from '../Grid/Grid.styles.js';
import { hostClass } from './Drawer.styles.js';

var layoutClasses = {
  "layer-left": "".concat(hostClass, "__layer ").concat(hostClass, "__left ").concat(hostClass, "__50"),
  "layer-right": "".concat(hostClass, "__layer ").concat(hostClass, "__right ").concat(hostClass, "__50"),
  "layer-full": "".concat(hostClass, "__layer ").concat(hostClass, "__right ").concat(hostClass, "__full"),
  "layer-left-75": "".concat(hostClass, "__layer ").concat(hostClass, "__left ").concat(hostClass, "__75"),
  "layer-right-75": "".concat(hostClass, "__layer ").concat(hostClass, "__right ").concat(hostClass, "__75"),
  "layer-right-25": "".concat(hostClass, "__layer ").concat(hostClass, "__right ").concat(hostClass, "__25"),
  "side-menu-left": "".concat(hostClass, "__side-menu ").concat(hostClass, "__left"),
  "side-menu-right": "".concat(hostClass, "__side-menu ").concat(hostClass, "__right"),
  "mega-menu": "".concat(hostClass, "__mega-menu"),
  "mega-menu-legacy": "".concat(hostClass, "__mega-menu-legacy")
};
var bodyMargin = "";

var addDrawerOpenListeners = function addDrawerOpenListeners(onKeyDown) {
  document.body.addEventListener("keydown", onKeyDown);
};

var removeDrawerOpenListeners = function removeDrawerOpenListeners(onKeyDown) {
  document.body.removeEventListener("keydown", onKeyDown);
};

var addScrollLock = function addScrollLock() {
  var scrollBarWidth = window.innerWidth - document.body.offsetWidth;
  document.body.classList.add("".concat(hostClass, "-scrolllock"));
  bodyMargin = document.body.style.marginRight;
  document.body.style.marginRight = "".concat(scrollBarWidth, "px");
};

var removeScrollLock = function removeScrollLock() {
  document.body.classList.remove("".concat(hostClass, "-scrolllock"));
  document.body.style.marginRight = bodyMargin;
}; // Hack to get rid of forwardRefs


var Div = fRef(function (_a) {
  var ref = _a.ref,
      props = __rest(_a, ["ref"]);

  return /*#__PURE__*/React.createElement("div", Object.assign({}, props, {
    ref: ref
  }));
});
var defaultProps = {
  layout: "layer-right"
};
var DrawerPresentation = fRef(function (props) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3;

  var noMargin = props.noMargin,
      className = props.className,
      layout = props.layout,
      transitionState = props.transitionState,
      open = props.open,
      onBackdropClick = props.onBackdropClick,
      contentRef = props.contentRef,
      htmlAttrs = props.htmlAttrs,
      ref = props.ref,
      children = props.children;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, layoutClasses[layout], true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    style: {
      display: transitionState && !transitionState.unmounted ? "inherit" : "none"
    },
    ref: ref
  }, /*#__PURE__*/React.createElement("div", Object.assign({}, htmlAttrs, {
    role: "dialog",
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__hidden"), transitionState && !transitionState.entering && !transitionState.entered), _cleanupClassObject2)),
    "aria-modal": open
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-background"),
    onClick: onBackdropClick,
    role: "none"
  }), /*#__PURE__*/React.createElement(Div, {
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-content"), true), _defineProperty(_cleanupClassObject3, "".concat(hostClass$1, "__md-col-6"), ["layer-left", "layer-right"].includes(layout)), _defineProperty(_cleanupClassObject3, "".concat(hostClass$1, "__md-col-8"), ["layer-left-75", "layer-right-75"].includes(layout)), _defineProperty(_cleanupClassObject3, "".concat(hostClass$1, "__sm-col-4"), ["layer-left", "layer-right"].includes(layout)), _defineProperty(_cleanupClassObject3, "".concat(hostClass$1, "__sm-col-6"), ["layer-left-75", "layer-right-75"].includes(layout)), _defineProperty(_cleanupClassObject3, "".concat(hostClass$1, "__xs-col-4"), ["layer-left", "layer-right", "layer-left-75", "layer-right-75"].includes(layout)), _cleanupClassObject3)),
    ref: contentRef
  }, children)));
}, defaultProps);

export { DrawerPresentation, addDrawerOpenListeners, addScrollLock, removeDrawerOpenListeners, removeScrollLock };
